import styled from 'styled-components';

export const EllipsisText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1.5rem 0 0;
  flex: 1;
`;
